module.exports = __webpack_public_path__ + "assets/images/b_y.daccdb6e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/risks/b_y.png
// module id = 374
// module chunks = 1